// Sentry configuration constants
export const SENTRY_DSN =
  'https://1ddd34ab015b9d0866d7375a19b054fe@o4506661542756352.ingest.us.sentry.io/4510189307494400';
